import axios from 'axios';
import {
  GET_BUSINESS_MODELS_REQUEST,
  GET_BUSINESS_MODELS_SUCCESS,
  GET_BUSINESS_MODELS_FAIL,
  CREATE_BUSINESS_MODEL_REQUEST,
  CREATE_BUSINESS_MODEL_SUCCESS,
  CREATE_BUSINESS_MODEL_FAIL,
  UPDATE_BUSINESS_MODEL_REQUEST,
  UPDATE_BUSINESS_MODEL_SUCCESS,
  UPDATE_BUSINESS_MODEL_FAIL,
  DELETE_BUSINESS_MODEL_REQUEST,
  DELETE_BUSINESS_MODEL_SUCCESS,
  DELETE_BUSINESS_MODEL_FAIL,
  baseURL
} from './types'; // Ensure baseURL is correctly defined here or in a config file

// Utility: Get token from localStorage
const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  const directToken = localStorage.getItem('token');
  console.log("adminBusinessModelActions - getAuthToken:", loginData.token || directToken);
  return loginData.token || directToken || '';
};

// Get auth headers configuration
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };
};

// Get All Business Models: POST /api/appointmentAdminBusinessModule/getall
export const getAllBusinessModels = (filters = {}) => async (dispatch) => {
  console.log("adminBusinessModelActions - getAllBusinessModels: Request initiated with filters:", filters);
  try {
    dispatch({ type: GET_BUSINESS_MODELS_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.post(
      `${baseURL}/api/appointmentAdminBusinessModule/getall`,
      filters,
      config
    );

    console.log("adminBusinessModelActions - getAllBusinessModels: API Response data:", data);

    // Assuming the API returns { success: 1, data: [...] }
    const modelsArray = data.success === 1 && Array.isArray(data.data) ? data.data : [];

    dispatch({
      type: GET_BUSINESS_MODELS_SUCCESS,
      payload: modelsArray // Explicitly pass the array of business models
    });
    console.log("adminBusinessModelActions - getAllBusinessModels: Dispatched GET_BUSINESS_MODELS_SUCCESS with payload count:", modelsArray.length);
    return Promise.resolve(data);

  } catch (error) {
    console.error("adminBusinessModelActions - Get Business Models Error:", error.response?.data || error.message);
    dispatch({
      type: GET_BUSINESS_MODELS_FAIL,
      payload: error.response?.data?.message || error.message
    });
    return Promise.reject(error);
  }
};

// Create Business Model: POST /api/appointmentAdminBusinessModule/create
export const createBusinessModel = (modelData) => async (dispatch) => {
  dispatch({ type: CREATE_BUSINESS_MODEL_REQUEST });
  try {
    const token = getAuthToken(); // Assuming getAuthToken is defined
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      `${baseURL}/api/appointmentAdminBusinessModule/create`,
      modelData,
      config
    );
    console.log("adminBusinessModelActions - createBusinessModel: API Response data:", response.data);
    // PROBLEM HERE: response.data.data is likely undefined or null if the API only sends a message
    dispatch({
      type: CREATE_BUSINESS_MODEL_SUCCESS,
      payload: response.data.data, // This is likely null
    });
  } catch (err) {
    console.error("adminBusinessModelActions - Create Business Model Error:", err.message || err);
    dispatch({
      type: CREATE_BUSINESS_MODEL_FAIL,
      payload: err.message || "Failed to create business model",
    });
  }
};
// Update Business Model: PATCH /api/appointmentAdminBusinessModule/update
export const updateBusinessModel = (modelData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_BUSINESS_MODEL_REQUEST });
    
    const config = getAuthHeaders();
    
    const { data } = await axios.patch(
      `${baseURL}/api/appointmentAdminBusinessModule/update`, 
      modelData, 
      config
    );
    
    dispatch({ 
      type: UPDATE_BUSINESS_MODEL_SUCCESS, 
      payload: data.updatedBusinessModel || data.data || data 
    });
    return Promise.resolve(data);
  } catch (error) {
    dispatch({ 
      type: UPDATE_BUSINESS_MODEL_FAIL, 
      payload: error.response?.data?.message || error.message 
    });
    return Promise.reject(error);
  }
};



// Delete Business Model: DELETE /api/appointmentAdminBusinessModule/delete
export const deleteBusinessModel = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_BUSINESS_MODEL_REQUEST });

    const config = getAuthHeaders();
    
    const { data } = await axios.delete(
      `${baseURL}/api/appointmentAdminBusinessModule/delete`,
      {
        ...config,
        data: { id } // Send ID in request body for DELETE
      }
    );

    dispatch({
      type: DELETE_BUSINESS_MODEL_SUCCESS,
      payload: id, // Return the deleted ID to remove from state
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: DELETE_BUSINESS_MODEL_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};